<div class="social" fxLayout="row">
    <img class="google" (click)="auth('google')" src="assets/images/google.svg" alt="Google logo" />
    <img (click)="auth('apple')" src="assets/images/apple.svg" alt="Apple logo" />
</div>